/* eslint-disable no-constant-condition */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import Select, { IOptions, SelectCustomProps } from '../Select';

interface IRHFSelectProps extends SelectCustomProps {
  name: string;
  onChange?: (event: any) => void;
  selectionMode?: 'none' | 'single' | 'multiple';
  options: IOptions[];
  placeholder?: string;
  size?: 'lg' | 'sm' | 'md' | undefined;
  classNames?: any;
}

const RHFSelect: React.FC<IRHFSelectProps> = ({
  name,
  onChange,
  selectionMode,
  options,
  placeholder,
  size,
  classNames,
  ...props
}) => {
  const { control } = useFormContext<Record<string, string>>();

  const [selectValue, setSelectValue] = useState<Set<string>>(new Set());

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange: onFieldChange }, fieldState: { error } }) => {
        const valueForm: any = new Set(Array.isArray(value) ? value.map(String) : []);

        return (
          <>
            {selectionMode === 'multiple' ? (
              <Select
                id={name}
                name={name}
                selectionMode={selectionMode}
                size={size}
                placeholder={placeholder}
                options={options}
                selectedKeys={valueForm || Array.from(selectValue)}
                value={valueForm || Array.from(selectValue)}
                onSelectionChange={(newSelection: any) => {
                  const updatedSelection: any = new Set(newSelection);

                  setSelectValue(updatedSelection); // Update local state

                  onFieldChange(Array.from(updatedSelection));
                  if (onChange) {
                    onChange(Array.from(updatedSelection));
                  }
                }}
                isInvalid={!!error}
                errorMessage={error?.message}
                classNames={{
                  trigger: "h-auto",
                  ...classNames
                }}
                {...props}
              />
            ) : (
              <Select
                id={name}
                name={name}
                placeholder={placeholder}
                options={options}
                value={value || ''}
                size={size}
                onChange={(e: any) => {
                  onFieldChange(e);
                  onChange?.(e);
                }}
                isInvalid={!!error}
                errorMessage={error?.message}
                classNames={classNames}
                {...props}
              />
            )}
          </>
        );
      }}
    />
  );
};

export default RHFSelect;
